import {
  Button,
  Icon,
  Image,
  StackProps,
  Text,
  VStack,
} from "@chakra-ui/react";
import { getCookie } from "typescript-cookie";
import { getCurrentActiveUser } from "../utils/helperFunction";
import { useNavigate } from "react-router-dom";
import { RiArrowRightDoubleLine } from "@remixicon/react";

interface Props extends StackProps {
  children?: any;
}

export const BuyerOnlyRoute = ({ children, ...rest }: Props) => {
  const navigate = useNavigate();
  const buyerToken = getCookie("buyerToken");
  const currentUser = getCurrentActiveUser();

  const handleClick = () => {
    navigate("/login", { replace: true });
  };

  if (!buyerToken || !currentUser || currentUser.role !== "buyer") {
    return (
      <VStack w={"100%"} my={"auto"} gap={0} justify={"center"} {...rest}>
        <Image
          w={"100%"}
          maxW={"350px"}
          src="/assets/svg/illustration_secure.svg"
        />

        <Text fontSize={[32, null, 34]} fontWeight={"semibold"}>
          {currentUser.role !== "buyer"
            ? `Pakai akun buyer kau lah bwangg`
            : `Login dulu dong bwangg!`}
        </Text>

        {!currentUser && (
          <Button
            mt={4}
            variant={"ghost"}
            colorScheme="red"
            size={["xs", null, "sm"]}
            onClick={handleClick}
            rightIcon={<Icon as={RiArrowRightDoubleLine} />}
          >
            Login Akun Buyer
          </Button>
        )}
      </VStack>
    );
  }

  return children;
};
